import { Variants } from "motion/react";

import { DRAWING_POLYLINE_COLOR } from "@ryde/shared";
import {
  deepPurpleMui,
  greyMui,
  orangeMui,
  redMui,
  rydeColors,
} from "@ryde/theme";

/**
 * Semantic accent per polyline tool action. Used as the icon color on hover and
 * as the fill when a toggle tool is armed — not as a resting full-button color.
 */
export const POLYLINE_TOOL_COLOR = {
  draw: rydeColors.reactSelectBlue,
  edit: orangeMui._600,
  manualPolyline: deepPurpleMui.A400,
  confirm: rydeColors.green,
  cancel: greyMui._800,
  snap: rydeColors.dragBorderColor,
  remove: redMui._600,
  deletePoint: redMui._600,
  undo: greyMui._800,
} as const;

/** Resting icon color — a calm neutral so the whole bar reads as one quiet toolbar. */
export const POLYLINE_TOOL_ICON_REST = greyMui._600;

/**
 * Tooltip fade/slide-in on hover (framer-motion).
 * `x: "-50%"` keeps the tooltip horizontally centered: framer writes the
 * element's inline `transform`, so centering must live here — a CSS
 * `transform: translateX(-50%)` would be overridden by the animation.
 */
export const POLYLINE_TOOL_TOOLTIP_VARIANTS: Variants = {
  hidden: { opacity: 0, x: "-50%", y: -2 },
  visible: { opacity: 1, x: "-50%", y: 0 },
};
export const POLYLINE_TOOL_TOOLTIP_TRANSITION = { duration: 0.12 };

/** Stacking inside the toolbar: the hovered button lifts above its neighbors
 * so its tooltip is never covered. */
export const POLYLINE_TOOL_Z_INDEX = { base: 1, active: 2 } as const;

/** CircleMarker style for the dot shown at each point placed while drawing. */
export const POLYLINE_DRAW_POINT_STYLE = {
  color: rydeColors.white,
  weight: 2,
  fillColor: DRAWING_POLYLINE_COLOR,
  fillOpacity: 1,
};
